<template>
<div name="student">

    <MobileHeader></MobileHeader>
    <div class="d-flex flex-row flex-column-fluid page">
        <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">

            <Header></Header>

            <!--begin::Content-->
            <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
                <!--begin::Entry-->
                <div class="d-flex flex-column-fluid">
                    <!--begin::Container-->
                    <!--begin::Dashboard-->

                    <div class="container">
                        <div class="row">
                            <!--begin::Content-->
                            <template v-for="cdata in courseData">
                                <!--begin::Col-->
                                <div class="col-xl-4" :key="cdata.id">
                                    <!--begin::Card-->
                                    <div class="card card-custom gutter-b card-stretch">
                                        <router-link :to="'/viewbundlelesson/'+cdata.cid">
                                            <!--begin::Body-->
                                            <div class="card-body">
                                                <!--begin::Info-->
                                                <div class="d-flex align-items-center">
                                                    <!--begin::Pic-->
                                                    <div class="flex-shrink-0 mr-4 symbol symbol-60 symbol-circle">
                                                        <img alt="Pic" :src="$root.URL_IMAGES+'Course/'+cdata.course_image">

                                                    </div>
                                                    <!--end::Pic-->
                                                    <!--begin::Info-->
                                                    <div class="d-flex flex-column mr-auto">
                                                        <!--begin: Title-->
                                                        <div class="d-flex flex-column mr-auto">
                                                            
                                                            <a class="text-dark text-hover-primary font-size-h4 font-weight-bolder mb-1">
                                                                {{cdata.course_name}}
                                                            </a>

                                                        
                                                            <!--<span class="text-muted font-weight-bold">Creates Limitless possibilities</span>-->
                                                        </div>
                                                        <!--end::Title-->
                                                    </div>
                                                    <!--end::Info-->
                                                </div>
                                                <!--end::Info-->
                                                <!--begin::Description-->
                                                <div class="mb-10 mt-5 font-weight-bold"> </div>
                                                <!--end::Description-->
                                                
                                                <!--begin::Progress-->

                                                <!--ebd::Progress-->
                                            </div>
                                            <!--end::Body-->
                                        </router-link>

                                    </div>
                                    <!--end:: Card-->
                                </div>
                                <!--end::Col-->
                            </template>
                            <!--end::Content-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import axios from 'axios'
import MobileHeader from '../../components/MobileHeader'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default {
    name: 'ViewBundleCourse',
    components: {
        Header,
        Footer,
        MobileHeader,

    },
    data() {
        return {
            uid:localStorage.getItem("uid"),
            role:localStorage.getItem("role"),
            courseData:[],
        }
    },
    mounted(){
            if(this.uid==null || this.uid=="" ){
                this.$router.push("/");
            }
            this.getCourse();
    },
    methods: {
        getCourse(){
            var ev = this;
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'lms_api.php',
                data: {
                    type: 'getMyBundleCourseList',
                    uid:this.uid,
                    gid:this.$route.params.id,
                }
            }).then(function (response) {
                var data=response.data;
                ev.courseData=data.data
                console.log(data)
            })  
        },
        
    },
}
</script>

<style scoped>

</style>
